'use client';

import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { CaptainChallengeData, captainChallengeSchema } from '@/components/schemas';

interface CaptainChallengeFormProps {
	onSubmit: (data: CaptainChallengeData) => void;
	onClose: () => void;
	title: string;
	dateTime: string;
	homeTeam: string;
	awayTeam: string;
}

export const CaptainChallengeForm = ({ onSubmit }: CaptainChallengeFormProps) => {
	const form = useForm<CaptainChallengeData>({
		resolver: zodResolver(captainChallengeSchema),
		defaultValues: {
			comment: ''
		}
	});

	const { handleSubmit } = form;

	return (
		<div className="space-y-6 bg-white">
			{/* <div className="space-y-4">
				<div className="flex items-center justify-between">
					<h3 className="font-inter text-lg font-semibold text-gray-700">{title}</h3>
					<span className="font-inter text-sm font-semibold text-gray-700">{dateTime}</span>
				</div>

				<div className="space-y-2">
					<div className="flex items-center gap-2">
						<span className="font-inter text-xl font-bold text-[#36F]">{awayTeam}</span>
						<span className="font-inter text-lg font-medium text-gray-700">(A)</span>
					</div>
					<div className="flex items-center gap-2">
						<span className="font-inter text-xl font-bold text-[#36F]">{homeTeam}</span>
						<span className="font-inter text-lg font-medium text-gray-700">(H)</span>
					</div>
				</div>
			</div> */}

			<form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
				{/* TODO-tala: Remove this alert once BE implementation is complete */}
				<div className="bg-yellow-50 mb-4 rounded-md bg-warning-100 p-4">
					<div className="flex items-center">
						<div className="shrink-0">
							<FontAwesomeIcon icon={faExclamationTriangle} className="text-yellow-400 size-5" aria-hidden="true" />
						</div>
						<div className="ml-3">
							<h3 className="text-yellow-800 text-sm font-medium">Feature Preview</h3>
							<div className="text-yellow-700 mt-2 text-sm">
								<p>
									This feature is coming soon! We&apos;re enhancing your experience with captain challenge functionality. Stay tuned
									for the update.
								</p>
							</div>
						</div>
					</div>
				</div>

				{/* <p className="text-sm font-medium text-gray-700">Let the commissioner know what you are challenging:</p>

				<TextArea
					{...register('comment')}
					placeholder="Describe your challenge (e.g., scoring dispute, rule interpretation)"
					hasError={!!formState.errors.comment}
					hint={formState.errors.comment?.message}
					className="min-h-[120px] w-full"
				/> */}

				{/* <ActionButtons
					className="flex justify-end gap-3"
					closeButtonClassName="w-32 text-gray-700"
					submitButtonClassName="w-32 bg-primary-600 text-white hover:bg-primary-700"
					onClose={onClose}
					submitButtonText="Submit"
					closeButtonText="Cancel"
					submitButtonDisabled
				/> */}
			</form>
		</div>
	);
};
